import accountAPI from '@/api/accounts'

export const getAccount = ({ commit }) => {
  accountAPI.getAccount(account => {
    commit('setWebName', account)
  })
}

export const getBusinessId = ({ commit }) => {
  accountAPI.getBusinessId(business => {
    commit('setBusinessId', business)
  })
}

export const logoutRMP = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    accountAPI.logoutRMP(response => {
      resolve()
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/actions.js